import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import Icon from 'Pods/Shared/Icon/Icon'
import UserAvatar from 'Pods/Shared/UserAvatar/UserAvatar'

function UserGalleryItem(props) {
  return (
    <div className="col-12 col-sm-6 col-md-4 col-xl-3">
      <article className="showcase-item showcase-item--square">
        <div className="showcase-item__content">
          <header className="showcase-item__header">
            <h3 className="showcase-item__title">
              <a
                className="showcase-item__title-link"
                href={`${props.type === 'tutorial' ? `/tutorials/${props.data.slug}` : `/gallery/project/${props.data.slug}`}`}
              >
                {props.data.title}
              </a>
            </h3>
            <div className="showcase-item__info">
              {props.type === 'tutorial' ? (
                <Fragment>
                  <div className="showcase-item__stats--tutorial">
                    <Icon type={['far', 'heart']} />
                    {props.data.likeCount}
                  </div>
                  <div className="showcase-item__stats--tutorial">
                    <Icon type={['far', 'comment']} />
                    {props.data.commentCount}
                  </div>
                  <div className="showcase-item__stats--tutorial">
                    <Icon type={['far', 'eye']} />
                    {props.data.viewCount}
                  </div>
                </Fragment>
              ) : (
                <Fragment>
                  <div className="showcase-item__stats">
                    <Icon type={['far', 'heart']} />
                    {props.data.likeCount}
                  </div>
                  <div className="showcase-item__author">
                    <a href={`/${props.data.author.username}`}>
                      <UserAvatar
                        userName={props.data.author.username}
                        size="small"
                        img={props.data.author.avatar}
                        isWithName
                      />
                    </a>
                  </div>
                </Fragment>
              )}
            </div>
          </header>
          <div className="showcase-item__image">
            <a
              href={`${props.type === 'tutorial' ? `/tutorials/${props.data.slug}` : `/gallery/project/${props.data.slug}`}`}
            >
              <img
                alt={props.data.title}
                src={props.data.primaryImage}
              />
            </a>
          </div>
        </div>
      </article>
    </div>
  )
}

UserGalleryItem.propTypes = {
  data: PropTypes.shape({
    title: PropTypes.string.isRequired,
    slug: PropTypes.string.isRequired,
    likeCount: PropTypes.number.isRequired,
    primaryImage: PropTypes.string.isRequired,
    author: PropTypes.shape({
      username: PropTypes.string.isRequired,
      avatar: PropTypes.string,
    }).isRequired,
  }).isRequired,
  type: PropTypes.string.isRequired,
}

export default UserGalleryItem
